
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, del, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { SpondMatch, Match, Player } from "../models/Models";
import { SpondService } from '../services/SpondService';
import { inject } from 'vue';
import router from '../router';

export default class SpondMatches extends Vue {
  public matches: Array<SpondMatch> = [];
  public matchesLoaded = false;
  private spondService: SpondService;

  public spondGroupName = '';

  async created() {
    this.spondService = inject('SpondService', new SpondService());

    this.spondService.getMatches()
      .then(async matches => {
        this.matches = matches;
        this.matchesLoaded = true;

        this.spondGroupName = await this.spondService.getSelectedGroupName();
      })
      .catch(async err => {
        if (err === 'no_group') {
          router.push({ name: "SpondGroups" });   
          return;
        } else if (err === 'no_token') {
          router.push({ name: "SpondLogin" });   
          return;
        } else {
          router.push({ name: "SpondLogin" });   
          return;
        }
      });
  }

  async createFromSpondMatch(spondMatch: SpondMatch) {
    if (!confirm(this.$t('spondMatches.confirmCreate') + ' ' + spondMatch.heading)) {
      return;
    }

    const match: Match = {
      id: spondMatch.id,
      homeCount: 0,
      opponent: spondMatch.heading,
      awayCount: 0,
      isRunning: false,
      hasStarted: false,
      totalSecondsPlayed: 0,
      homeGame: undefined,
      matchPlayedTime: "",
      lastStarted: undefined,
      players: [],
      created: moment().format('YYYY-MM-DD HH:mm:ss')
    };

    spondMatch.players.forEach(p => {
      const newPlayer: Player = {
        id: p.id,
        key: p.id,
        name: p.shortName,
        lastSecondsOnField: 0,
        lastSecondsOfField: 0,
        totalSecondsOnField: 0,
        lastOnField: undefined,
        lastOfField: undefined,
        isOnField: false,
        lastStartOnField: undefined,
        _editing: false,
        _editingName: undefined,
        _timeOnField: "00:00",
        _timeOffField: "00:00",
        _timeTotal: "00:00"
      };

      match.players.push(newPlayer);
    });

    await set(match.id, match);

    router.push({ name: "MatchDetails", params: { id: match.id } });    
  }

  goToMatch(match: SpondMatch) {   
    router.push({ name: "MatchDetails", params: { id: match.id } });    
  }
  
  async signout() {
    await this.spondService.signout();
    
    router.push({ name: "Matches" });  
  }
}
